<div class="diapo-container">
	<div class="img-container">
		<img *ngIf="mainImage" [src]="getImage(mainImage)" [alt]="mainImage?.name"/>
		<div class="banner-container">
      <div *ngIf="product.isNew" [ngStyle]="getStyle('news')" class="banner">
        Nouveautés
      </div>
      <div *ngIf="product.isPromo" [ngStyle]="getStyle('promos')" class="banner">
        Promotion
      </div>
			<gob-banner [banners]="product?.banners"></gob-banner>
		</div>
	</div>
  <gob-gallery [product]="product"></gob-gallery>
</div>
